exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-avatar-dropdown {\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n}\n.user-avatar-dropdown .ivu-badge-dot {\n  top: 16px;\n}\n", ""]);

// exports
